<app-toasts
  style="position: fixed; top: 70px; right: 20px; z-index: 1003"
  aria-live="polite"
  aria-atomic="true"
></app-toasts>

<!-- Vertical layout -->
<app-vertical *ngIf="isVerticalLayoutRequested()"></app-vertical>

<!-- horizontal layout -->
<app-horizontal *ngIf="isHorizontalLayoutRequested()"></app-horizontal>
